// extracted by mini-css-extract-plugin
module.exports = {"container":"NoDealsWidget_container____6ZT","icon":"NoDealsWidget_icon__3xz3U","errorContainer":"NoDealsWidget_errorContainer__354FK","errorText":"NoDealsWidget_errorText__1NbKb"};